<template>
    <div class="ClientPhysicianOrderList">
        <div>
            <h2>
                Physician Orders
                <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" /> <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowNewOrder()" class="olive-green-text pointer" />
            </h2>

            <form class="table-filters">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Order Status:</label>
                            <select class="form-control" v-model="Filters.IsActive" @change="RefreshDataTable()">
                                <option :value="null">All</option>
                                <option :value="true">Active</option>
                                <option :value="false">Discontinued</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Medication Type:</label>
                            <select class="form-control" v-model="Filters.MedicationType" @change="RefreshDataTable()">
                                <option value="Prescription">Prescriptions</option>
                                <option value="OTC">OTCs</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div style="overflow-x:auto;">
            <vuetable :fields="TableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable">

                <template slot="Inventory" scope="props">
                    <div class="Inventory">
                        <font-awesome-icon :icon="['fa', 'clipboard']" v-on:click="ShowInventory(props.rowData)" class="pointer" />
                    </div>
                </template>
                <template slot="Discontinue" scope="props">
                    <div class="Discontinue">
                        <span v-if="props.rowData.DiscontinuedDateTime">{{formatDate(props.rowData.DiscontinuedDateTime,'MM/DD/YY hh:mm A')}}</span>
                        <span v-else v-b-tooltip.hover title="Discontinue Medication"><font-awesome-icon :icon="['fa', 'ban']" v-on:click="ShowDiscontinue(props.rowData.Id)" class="red pointer" /></span>
                    </div>
                </template>
                <template slot="DeleteOrder" scope="props">
                    <div class="DeleteOrder">
                        <DeleteIconRequest :requires-confirmation="true"
                                           confirmation-string="You are about to delete this entire Physician Order.  If there are existing inventories, dispensations, counts, or destructions, those records will be deleted along with this."
                                           :endpoint="'Medication/PhysicianOrder/' + props.rowData.Id"
                                           :payload="{}"
                                           v-on:success="GetList(true)"
                                           method="DELETE" />
                    </div>
                </template>
            </vuetable>
        </div>

        <!--NEW ORDER MODAL-->
        <b-modal ref="modal-neworder" size="lg" title="ADD NEW PHYSICIAN ORDER" hide-footer>
            <b-container>
                <b-form @submit="Save">
                    <b-row>
                        <b-col>
                            <h3>Physician Info</h3>
                            <div class="form-group">
                                <label>Physician Name:</label>
                                <input v-model="TargetRecord.PhysicianName" type="text" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Physician Phone Number:</label>
                                <input v-model="TargetRecord.PhysicianPhoneNumber" type="text" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Clinic Name:</label>
                                <input v-model="TargetRecord.ClinicName" type="text" class="form-control" required />
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Medication Info</h3>
                            <div class="form-group">
                                <label>Medication Name:</label>
                                <input v-model="TargetRecord.Name" type="text" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Strength:</label>
                                <input v-model="TargetRecord.Strength" type="text" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Route:</label>
                                <input v-model="TargetRecord.Route" type="text" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Purpose:</label>
                                <input v-model="TargetRecord.Purpose" type="text" class="form-control" required />
                            </div>
                            <div class="form-group">
                                <label>Warnings:</label>
                                <input v-model="TargetRecord.Warnings" type="text" class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Medication Type:</label>
                                <select class="form-control" v-model="TargetRecord.MedicationType" required>
                                    <option value="Scheduled">Scheduled Prescription</option>
                                    <option value="PRN">PRN Prescription</option>
                                    <option value="OTC">OTC</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="TargetRecord.MedicationType == 'Scheduled'">
                                <label>Scheduled Doses: <font-awesome-icon :icon="['fa', 'plus']" v-on:click="AddDose()" class="olive-green-text pointer" /></label>
                                <table class="table-utility">
                                    <thead>
                                        <tr>
                                            <th>Qty</th>
                                            <th></th>
                                            <th>Time</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(dose, index) in TargetRecord.MedicationPhysicianOrderDoses">
                                            <td>
                                                <input type="number" v-model="dose.Amount" class="form-control" step="0.1" required />
                                            </td>
                                            <td>
                                                AT
                                            </td>
                                            <td>
                                                <select v-model="dose.Hour" class="form-control" required>
                                                    <option value="1">1 AM</option>
                                                    <option value="2">2 AM</option>
                                                    <option value="3">3 AM</option>
                                                    <option value="4">4 AM</option>
                                                    <option value="5">5 AM</option>
                                                    <option value="6">6 AM</option>
                                                    <option value="7">7 AM</option>
                                                    <option value="8">8 AM</option>
                                                    <option value="9">9 AM</option>
                                                    <option value="10">10 AM</option>
                                                    <option value="11">11 AM</option>
                                                    <option value="12">12 PM (noon)</option>
                                                    <option value="13">1 PM</option>
                                                    <option value="14">2 PM</option>
                                                    <option value="15">3 PM</option>
                                                    <option value="16">4 PM</option>
                                                    <option value="17">5 PM</option>
                                                    <option value="18">6 PM</option>
                                                    <option value="19">7 PM</option>
                                                    <option value="20">8 PM</option>
                                                    <option value="21">9 PM</option>
                                                    <option value="22">10 PM</option>
                                                    <option value="23">11 PM</option>
                                                </select>
                                            </td>
                                            <td>
                                                <font-awesome-icon v-if="index != 0" :icon="['fa', 'minus']" v-on:click="RemoveDose(index)" class="red pointer" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="form-group">
                                <label>Unit Type:</label>
                                <select class="form-control" v-model="TargetRecord.UnitType" required>
                                    <option value="Tablets">Tablets</option>
                                    <option value="Drops">Drops</option>
                                    <option value="Sprays">Sprays</option>
                                    <option value="Oz">Oz</option>
                                    <option value="Globs">Globs</option>
                                    <option value="Units">Units (other)</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>Psychiatric?</label>
                                <select class="form-control" v-model="TargetRecord.IsPsychiatric" required>
                                    <option :value="false">Non-Psychiatric</option>
                                    <option :value="true">Psychiatric</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Start Authorization</h3>
                            <div class="form-group">
                                <label>Medication Start Date/Time:</label>
                                <flat-pickr v-model="TargetRecord.StartDateTime" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Signed Authorization Document (Prescription, Discharge Orders, etc):</label>
                                <b-form-file v-model="TargetRecord.StartOrderDocumentScan"
                                             class="form-control"
                                             accept=".pdf">
                                </b-form-file>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelNewOrder()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--NEW ORDER MODAL-->
        <b-modal ref="modal-discontinue" size="lg" title="DISCONTINUE PHYSICIAN ORDER" hide-footer>
            <b-container>
                <b-form @submit="SaveDiscontinue">
                    <b-row>
                        <b-col>
                            <h3>Discontinue Authorization</h3>
                            <div class="form-group">
                                <label>Medication Discontinue Date/Time:</label>
                                <flat-pickr v-model="DiscontinueData.DiscontinuedDateTime" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Comments on Discontinuation:</label>
                                <textarea rows="4" class="form-control" v-model="DiscontinueData.DiscontinueComments"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Signed Authorization Document (Prescription Update, Discharge Orders, etc):</label>
                                <b-form-file v-model="DiscontinueData.DiscontinueOrderDocumentScan"
                                             class="form-control"
                                             accept=".pdf">
                                </b-form-file>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelDiscontinue()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                DISCONTINUE MEDICATION
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <Inventory ref="inventory" />
    </div>
</template>

<script>
    
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import DeleteIconRequest from '../ItemEditors/DeleteIconRequest.vue';

    import Inventory from './Inventory.vue';

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faClipboard } from '@fortawesome/free-solid-svg-icons';
    library.add(faClipboard);
    import { faBan } from '@fortawesome/free-solid-svg-icons';
    library.add(faBan);
    

    export default {
        props: [
            "ClientSubProgramMembershipId"
        ],
        data: function () {
            return {
                Filters: {
                    IsActive: true,
                    MedicationType: "Prescription"
                },
                TargetRecord: {
                    MedicationPhysicianOrderDoses: []
                },
                TableOptions: {
                    Fields: [
                        {
                            name: 'Name',
                            title: "Name",
                            sortField: 'Name'
                        },
                        {
                            name: 'Strength',
                            title: "Strength",
                            sortField: 'DOB'
                        },
                        {
                            name: 'DoseDescriptions',
                            title: "Dose/Times",
                            sortField: 'DoseDescriptions'
                        },
                        {
                            name: 'StartDateTime',
                            title: "Started",
                            callback: 'formatDate|MM/DD/YY hh:mm A',
                            sortField: 'StartDateTime'
                        },
                        {
                            name: '__slot:Discontinue',
                            title: 'Discontinued',
                            sortField: 'DiscontinuedDateTime'
                        },
                        {
                            name: '__slot:Inventory',
                            title: 'Inventory',
                        },
                        {
                            name: '__slot:DeleteOrder',
                            title: 'Delete',
                        }
                    ]
                },
                DataList: [],
                DiscontinueData: {},
                DateTimeConfig: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y h:i K',
                },
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetList(true);
            },

            //ENDPOINTS
            GetList(displayLoad = false) {
                this.Filters.ClientSubProgramMembershipID = this.ClientSubProgramMembershipId;
                this.$MasterAPI.ExecuteRequest("GET", "Medication/PhysicianOrder", this.Filters, this.GetListSuccess,()=>{}, displayLoad);
            },
            GetListSuccess(response) {
                this.DataList = response.data.data;
                this.$refs.datatable.refresh();
            },
            Save(e) {
                e.preventDefault();
                let vm = this;
                const formData = new FormData();
                for (var key in vm.TargetRecord) {
                    if (key == "MedicationPhysicianOrderDoses" && vm.TargetRecord[key] != null) {
                        let valueString = "";
                        let valueArray = []
                        vm.TargetRecord.MedicationPhysicianOrderDoses.forEach(function (item) {
                            valueArray.push(item.Amount + "-" + item.Hour);
                        });
                        valueString = valueArray.join(",");
                        formData.append(key, valueString);
                    }
                    else if (vm.TargetRecord[key] != null) {
                        formData.append(key, vm.TargetRecord[key]);
                    }
                }
                formData.append("ClientSubProgramMembershipID", vm.ClientSubProgramMembershipId);

                this.$MasterAPI.ExecuteRequest("POST", "Medication/PhysicianOrder", formData, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                this.GetList(true);
                this.$refs["modal-neworder"].hide();
            },
            SaveDiscontinue(e) {
                e.preventDefault();

                let vm = this;
                const formData = new FormData();
                for (var key in vm.DiscontinueData) {
                    if (vm.DiscontinueData[key] != null) {
                        formData.append(key, vm.DiscontinueData[key]);
                    }
                }

                this.$MasterAPI.ExecuteRequest("PUT", "Medication/PhysicianOrder", formData, this.SaveDiscontinueSuccess, () => { }, true);
            },
            SaveDiscontinueSuccess(response) {
                this.GetList(true);
                this.$refs["modal-discontinue"].hide();
            },
            // UI
            ShowNewOrder() {
                this.TargetRecord = {
                    MedicationPhysicianOrderDoses: [
                        {
                            Hour: "",
                            Amount: ""
                        }
                    ]
                };
                this.$refs["modal-neworder"].show();
            },
            CancelNewOrder() {
                this.$refs["modal-neworder"].hide();
            },
            AddDose() {
                this.TargetRecord.MedicationPhysicianOrderDoses.push({
                    Amount: "",
                    Hour: ""
                });
            },
            RemoveDose(index) {
                if (index != 0) {
                    this.TargetRecord.MedicationPhysicianOrderDoses.splice(index, 1);
                }
                
            },
            ShowInventory(rowData) {
                this.$refs["inventory"].ShowThis(rowData.Id, rowData.Name, rowData.Strength, rowData.DoseDescriptions);
            },
            ShowDiscontinue(orderID) {
                this.DiscontinueData = {
                    Id: orderID
                }
                this.$refs["modal-discontinue"].show();
            },
            CancelDiscontinue() {
                this.$refs["modal-discontinue"].hide();
            },
            // AUXILLARY
            formatDate (value, fmt = 'MM/DD/YY', defaultVal = '') {
              return (value == null)
                ? defaultVal
                : moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.DataList
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            }
        },
        components: {
            Vuetable,
            flatPickr,
            DeleteIconRequest,
            Inventory
        },
        computed: {

        },
        mounted() {
            if (this.CheckPermission("Medication.PhysicianOrder.Delete")) {
                this.TableOptions.Fields.push(
                    {
                        name: '__slot:DeleteOrder',
                        title: 'Delete',
                    }
                )
            }
            this.GetList(true);
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>